import React from "react";
import SampleSelector from "../../editor/SampleSelector";
import {connect} from "react-redux";
import {decomposeNewsletter} from "../../../services/block/newsletter";
import {setCurrentLayout, setCurrentNewsletterTemplate, setNewsletterBlocks, initNewsletterBlocks} from "actions";
import _ from "i18n";
import {setTTPDialogCustomData} from "../../../actions/actions/params";
import { toast } from "react-toastify";
class NSTemplateSelector extends React.Component {
  state = {
    loadingTemplate: false,
  };

  componentDidMount() {
    const { childRef, currentTemplate, proceed } = this.props;

    // Vérifiez si `proceed` est passé et définissez l'action secondaire si nécessaire
    if (childRef) {
      childRef({
        secondaryAction: () => {
          if (currentTemplate && proceed) {
            proceed();
          } else {
            this.showWarning();
          }
        }
      });
    }
  }

  showWarning = () => {
    toast.warning(_("Please select a template to proceed"), _("warning"));
  };

  loadTemplate = (template) => {
    if (!template || !template.id) {
      return;
    }

    const { setCurrentLayout, setCurrentNewsletterTemplate, setNewsletterBlocks, initNewsletterBlocks, proceed, blocks } = this.props;

    // Initialisation des blocs de la newsletter
    initNewsletterBlocks();
    setCurrentLayout(template.id);
    setCurrentNewsletterTemplate(template);

    if (!this.state.loadingTemplate) {
      this.setState({ loadingTemplate: true });
      let feeds = blocks.reduce((acc, { feeds }) => {
        return [...acc, ...feeds];
      }, []);
      
      decomposeNewsletter(template, (blocks) => {
        let i = 0;
        blocks = feeds && feeds.length > 0 ? blocks.map(block => {
          if (block.type !== "UNREFERENCED_BLOCK" && feeds.length > i) {
            block.feeds = feeds.slice(i, i += block.column);
            return block;
          }
          return block;
        }) : blocks;

        setNewsletterBlocks(blocks);
        this.setState({ loadingTemplate: false });
        // Si `proceed` existe, l'exécuter
        if (proceed) {
          proceed();
        } else {
          //this.showWarning();
        }
      });
    }
  };

  handleConfirmTemplate = (template) => {
    const { currentTemplate, setTTPDialogCustomData } = this.props;

    // Vérification si un template est déjà sélectionné et s'il est différent
    if (currentTemplate && currentTemplate.id !== template?.id) {
      setTTPDialogCustomData({
        'approvedAction': () => this.loadTemplate(template),
        'message': _('confirmSwitchTheme'),
        'title': "Confirmation of switching models"
      });
    } else {
      this.loadTemplate(template);
    }
  };

  render() {
    return (
      <SampleSelector 
        type={["TEMPLATE"]} 
        onSelect={this.handleConfirmTemplate} 
        currentTheme={this.props.currentTemplate?.id} 
      />
    );
  }
}

const mapStateToProps = store => ({
  currentTemplate: store.themes.newsletter.currentTemplate,
  blocks: store.themes.newsletter.blocks,
});

const mapDispatchToProps = dispatch => ({
  setCurrentLayout: (data) => dispatch(setCurrentLayout(data)),
  setCurrentNewsletterTemplate: (data) => dispatch(setCurrentNewsletterTemplate(data)),
  setNewsletterBlocks: (data) => dispatch(setNewsletterBlocks(data)),
  initNewsletterBlocks: () => dispatch(initNewsletterBlocks()),
  setTTPDialogCustomData: data => dispatch(setTTPDialogCustomData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NSTemplateSelector);
